import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { ApiNewsService } from './api-call-providers/api-news.service';
import { DataCacheService } from './data-cache.service';

export class News {

  id: string;
  title: string;
  body: string;
  category: string;
  isImportant: boolean;
  start: number;
  end: number;
  created: number;

  constructor(data) {
    this.id = data.id;
    this.title = data.title;
    this.body = data.body
    this.category = data.category;
    this.isImportant = data.isImportant;
    this.start = data.start;
    this.end = data.end;
    this.created = data.created;
  }

}

@Injectable()
export class NewsService {

  private newsSource = new Subject<any>();
  newsList = this.newsSource.asObservable();;

  constructor(
    private _dataCacheService: DataCacheService,
    private _apiNewsService: ApiNewsService,
  ) {
  }

  get loading() {
    return this._apiNewsService.isLoading
  }

  /**
   * データの初期化
   */
  async load() {
    this._apiNewsService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.NEWS_DATA)
    if (!_data.isExist()) {
      await this.fetch();
      return
    }
    this._apiNewsService.isLoading = false
    return this.newsSource.next(_data);
  }

  /**
   * ニュースリスト取得する
   */
  async fetch() {
    let res: any = await this._apiNewsService.list()
    let data = { data: res.newsList }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.NEWS_DATA, res.newsList, res.expired)
    }
    this.newsSource.next(data)
  }

  /**
   * 既読処理
   * @param news News
   */
  async read(news: News) {
    return await new Promise((resolve, reject) => {
      resolve()
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/news.service.ts